import React from 'react';
import {Container, Row, Col, Figure} from 'react-bootstrap';
import './Home.css';

const Branches = () => {
    return ( 
        <Container>
        <Row>
          <Col xs={12} md={12}>
          <Figure className="itemsimg">
        <Figure.Image
          width={850}
          height={850}
          alt="171x180"
          src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596770/nonedb/BUK_HQ_kxz4xs.jpg"
        />
        <Figure.Caption>
        
        </Figure.Caption>
      </Figure>  
            
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
          <Figure className="itemsimg">
        <Figure.Image
          width={850}
          height={850}
          alt="171x180"
          src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611671374/nonedb/Our_Stores_nwnxbf.jpg"
        />
        <Figure.Caption>
        
        </Figure.Caption>
      </Figure>  
         </Col>
        </Row>        
      </Container>
     );
};
 
export default Branches;